import { render, staticRenderFns } from "./Chapter4_2.vue?vue&type=template&id=533d5b63&scoped=true&"
import script from "./Chapter4_2.vue?vue&type=script&lang=js&"
export * from "./Chapter4_2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "533d5b63",
  null
  
)

export default component.exports